/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { MobileSinglePicker, MobileSinglePickerPayload } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MobilePickerController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-picker-controller
   * @name GetMobileSinglePicker
   * @request POST:/api/m/picker/single
   */
  getMobileSinglePicker = (data: MobileSinglePickerPayload, params: RequestParams = {}) =>
    this.http.request<MobileSinglePicker, any>({
      path: `/m/picker/single`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getMobileSinglePickerPath = '/m/picker/single'
  static getMobileSinglePickerMethod = 'POST'
}
